/**
 * /t/$slug/recoveries/attest/$requestId — peer attestation page.
 *
 * A user lands here from a recovery email after a colleague named
 * them as one of two trusted peers. The page authenticates via
 * the user's existing session (peer must be logged in to pureid)
 * and surfaces the request snapshot + approve/deny buttons.
 */

import { createFileRoute } from "@tanstack/react-router";
import { RecoveryAttestPage } from "@/features/recovery-attest/pages/recovery-attest-page";

export const Route = createFileRoute("/t/$slug/recoveries/attest/$requestId")({
  component: RecoveryAttestPage,
});
